export default {
    home:'Home',
    gallery:'Gallery',
    files:'Files',
    file:'File',
    download:'Download',
    downloads:'Downloads',
    upload:'Upload Photo',
    music:'Music',
    videos:'Videos',
    books:'Books',
    settings:'Settings',
    categories:'Categories',
    games:'Games',
    search_placeholder:'Search : File , Music , Video , Uploaders And More',
    theme:'Theme',
    language:'Language',
    darkmode:'Darkmode',
    lightmode:'Lightmode',
    username:'Username',
    password:'Password',
} 